import { JournalRole } from '@cpce/database/enums';
export const JOURNAL_ROLE_LABELS = {
    [JournalRole.sales]: 'Ventes',
    [JournalRole.purchases]: 'Achats',
    [JournalRole.bank]: 'Banque',
    [JournalRole.misc]: 'Opérations diverses',
    [JournalRole.openingBalances]: 'À-nouveaux',
};
// What each role posts, as shown next to the role picker.
export const JOURNAL_ROLE_DESCRIPTIONS = {
    [JournalRole.sales]: 'écritures de vente des inscriptions aux prestations',
    [JournalRole.purchases]: 'factures fournisseurs créées depuis les commandes, acquisitions d’immobilisations',
    [JournalRole.bank]: 'saisies de trésorerie sur un compte sans journal associé',
    [JournalRole.misc]: 'dotations aux amortissements',
    [JournalRole.openingBalances]: 'à-nouveaux, requis pour clôturer',
};
// The code each role was hardcoded to before roles existed. A role nobody holds falls back to
// the journal with this code, so a comité that never designated anything keeps working.
export const JOURNAL_ROLE_DEFAULT_CODES = {
    [JournalRole.sales]: 'VEN',
    [JournalRole.purchases]: 'ACH',
    [JournalRole.bank]: 'BFO',
    [JournalRole.misc]: 'OD',
    [JournalRole.openingBalances]: 'AN',
};
export function missingJournalRoleMessage(role) {
    return (`Aucun journal « ${JOURNAL_ROLE_LABELS[role]} » n'est désigné. ` +
        `Rendez-vous dans Paramètres comptables → Journaux et attribuez le rôle « ${JOURNAL_ROLE_LABELS[role]} » au journal concerné.`);
}
export function findJournalForRole(journals, role) {
    return (journals.find((journal) => journal.role === role) ??
        journals
            .filter((journal) => journal.code === JOURNAL_ROLE_DEFAULT_CODES[role])
            .sort((a, b) => a.id - b.id)[0]);
}
